<template>
    <x-card style="height: 100%" class="rounded-lg pb-6">
        <v-card-title class="d-flex mx-5 py-0">
            <!-- <span v-if="isMediumAndUp">Payments</span> -->
            <v-select
                dense
                outlined
                class="d-flex ml-auto pt-3 pb-0"
                :items="sessions"
                v-model="selectedSession"
                return-object
                item-text="name"
                placeholder="Select session"
                :style="[{ maxWidth: isMediumAndUp ? '20%': isMediumAndDown ? '30%' : '60%'}]"
            />
        </v-card-title>


        <v-divider/>

        <x-card-text>
            <!--  body div  -->
            <v-data-table :headers="headers" :loading="loading" disable-pagination class="mx-2" hide-default-footer
                          :items="itemsWithSerialNo">
                <template v-slot:[`item.status`]="{ item }">
                    <span class="success--text" v-if="(item.payment != null && item.payment.cleared)">{{
                            'Paid'
                        }}</span>
                    <span class="error--text" v-else>{{ 'Not paid' }}</span>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                    <span>{{ (item.payment == null ? item.fee.amount : item.payment.invoiceAmount) }}</span>
                </template>

                <template v-slot:[`item.invoice`]="{ item }">
                    <span>{{ item.payment == null ? 'None' : item.payment.transactionId }}</span>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <v-menu bottom left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn dark icon v-bind="attrs" v-on="on">
                                <v-icon color="black">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item link @click="initializeTransaction(item.fee, item.payment)">
                                <v-list-item-title> Invoice</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="loadPaymentGateway(item.payment, item.fee)" link
                                         :disabled="item.payment == null || (item.payment != null && item.payment.cleared)">
                                <v-list-item-title> Pay</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
            </v-data-table>
            <v-spacer></v-spacer>
        </x-card-text>

        <loading-dialog :show="loading"></loading-dialog>
        <message-box :show="messageShow" :message="message" :type="messageType"
                     v-on:close-message="messageShow = !messageShow"></message-box>
    </x-card>
</template>


<script>
import {mapGetters} from "vuex";
import Roles from "shared/Roles";
import XButton from '@ui/widgets/XButton.vue';
import XCard from 'ui/components/XCard.vue';
import XTextField from 'ui/widgets/XTextField.vue';
import XCardText from 'ui/components/XCardText.vue';
import XCardTitle from 'ui/components/XCardTitle.vue';
import XSelect from '@ui/widgets/XSelect.vue';
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import Api from 'main/api';
import {PaymentGateway} from "shared/PaymentGateway";
import GateWays from "shared/GateWays";
import Links from "shared/constants/Links";
import ErrorResolver from "@/shared/ErrorResolver";
import LoginUtil from "@/login/LoginUtil";


export default {
    name: "OtherFees",
    components: {
        XButton,
        XSelect,
        XCard,
        XTextField,
        XCard,
        XCardText,
        XCardTitle,
        LoadingDialog,
        MessageBox
    },

    data: () => ({
        messageType: '',
        message: '',
        messageShow: false,
        loading: false,
        feePayment: null,
        items: [],
        paymentInfo: null,
        sessions: [],
        selectedSession: null,
        paymentGateway: null,
        paymentConfig: null,
        headers: [
            {
                text: "S/N",
                align: "start",
                value: "sno",
                sortable: false,
            },
            {
                text: "Title",
                align: "start",
                value: "fee.feeItemTitle.title",
            },
            {text: "Amount", value: "amount"},
            {text: "Invoice", value: "invoice"},
            {text: "Status", value: "status", sortable: false},
            {text: "Actions", value: "actions", sortable: false},
        ],
    }),

    computed: {
        ...mapGetters(['getUser']),
        isLargeAndUp: function () {
            return this.$vuetify.breakpoint.lgAndUp
        },

        isMobile: function () {
            return this.$vuetify.breakpoint.smAndDown
        },

        isMedium: function () {
            return this.$vuetify.breakpoint.mdOnly
        },

        isMediumAndDown: function () {
            return this.$vuetify.breakpoint.sm
        },


        isMediumAndUp: function () {
            return this.$vuetify.breakpoint.mdAndUp
        },

        itemsWithSerialNo() {
            return this.items.map((d, index) => ({...d, sno: index + 1}))
        },

        totalAmount: function () {
            return this.items.map(value => value.amount).reduce((previousValue, currentValue) => previousValue + currentValue, 0)
        },

        amountPaid: function () {
            if (this.feePayment != null && this.feePayment.cleared)
                return this.totalAmount

            if (this.parts.length < 1) {
                return 0;
            }

            return this.parts.map(e => e.amountPaid).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
        },

        canClickPay: function () {
            return /^[123456789]\d*(\.\d{0,8})?$/.test(this.amountToPay) && Number.parseFloat(this.amountToPay) <= (this.totalAmount - this.amountPaid)
        },

        isApplicant: function () {
            return this.getUser != null && Roles.contains(this.getUser.roles, Roles.Applicant)
        }
    },


    methods: {
        getPayment() {
            if (this.getUser != null && this.selectedSession != null) {
                this.loading = true;
                this.feePayment = null
                this.items = [];
                Api.schoolFees.standaloneForUser(this.selectedSession.id, this.getUser.userId)
                    .then(res => {
                        this.items = res.data
                    }).catch(err => ErrorResolver.checkErrors(this, err))
                    .finally(() => this.loading = false)
            }
        },

        initializeTransaction(fee, payment) {
            if (this.getUser != null && fee != null) {
                if (payment == null) {
                    this.loading = true;
                    Api.payment.initializeStandalone(this.getUser.userId, fee.id)
                        .then(res => {
                            this.message = 'Invoice generated'
                            this.messageType = 'success'
                            this.messageShow = true
                            this.downloadInvoice(res.data)
                            this.getPayment();
                        }).catch(err => ErrorResolver.checkErrors(this, err))
                        .finally(() => this.loading = false)
                } else {
                    this.downloadInvoice(payment)
                }
            }
        },

        // invoice download
        downloadInvoice(payment) {
            this.loading = true;
            Api.payment.downloadStandaloneInvoice(payment.id)
                .then(res => {
                    let fileURL = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
                    let fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'invoice.pdf');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    fileLink.remove();
                }).catch(err => ErrorResolver.checkErrors(this, err)).finally(() => this.loading = false)
        },

        // TODO: To be removed
        refreshTransaction() {
            if (this.getUser != null && this.selectedSession != null && this.feePayment != null) {
                this.loading = true;
                Api.schoolFees.refreshTransaction(this.feePayment.id)
                    .then(res => {
                        this.feePayment = res.data;
                        this.message = 'Transaction refreshed'
                        this.messageType = 'success'
                        this.messageShow = true
                    }).catch(err => ErrorResolver.checkErrors(this, err))
                    .finally(() => this.loading = false)
            }
        },

        // eslint-disable-next-line no-unused-vars
        makePayment(payment) {
            if (payment != null) {
                if (this.paymentConfig.inline) {
                    this.paymentGateway.makePayment({
                        email: this.getUser.email,
                        amount: payment.invoiceAmount,
                        currency: 'NGN',
                        invoice: payment.transactionId,
                        paymentId: payment.id
                    }, (data) => {
                        // if its an applicant, logout 'em out
                        if (this.isApplicant) {
                            LoginUtil.resetAccessToken()
                            LoginUtil.resetRefreshToken()
                            window.location.href = '/login'
                        } else {
                            window.location.reload()
                        }
                    }, (invoice) => {
                        // process
                        // this.loading = true
                        this.getPayment()
                        Api.payment.processInline(invoice)
                            .then(() => {
                                window.location.href = "/student#/other_fees"
                            }).catch(err => {
                            ErrorResolver.checkErrors(this, err)
                            this.loading = false
                        }).finally(() => this.loading = false)
                    })
                } else {
                    // payment should not be done inline
                    // open window for payment
                    this.loading = true
                    window.location.href = payment.paymentLink
                }
            }
        },

        fetchSessionsForPayment() {
            if (this.getUser != null) {
                this.loading = true;
                Api.session.getSessionsForPayment(this.getUser.userId)
                    .then(res => this.sessions = res.data)
                    .catch(err => ErrorResolver.checkErrors(this, err))
                    .finally(() => this.loading = false);
            }
        },

        loadPaymentGateway(payment, standalone) {
            this.loading = true
            this.paymentGateway = new PaymentGateway(GateWays.REMITA, this, Links.payments.processInlinePayment)
            Api.paymentPlatforms.find(standalone.paymentPlatform.name)
                .then(res => {
                    if (this.paymentGateway != null) {
                        // set config
                        this.paymentConfig = res.data
                        // if inline, initialize
                        if (res.data.inline) {
                            setTimeout(() => {
                                this.paymentGateway.initializeGateway(res.data, () => {
                                    // make payment
                                    this.makePayment(payment)
                                    this.loading = false
                                })

                            }, 1000)
                        } else { // not inline. make direct payment
                            this.makePayment(payment)
                        }
                    } else {
                        this.message = 'No payment settings found'
                        this.messageType = 'error'
                        this.messageShow = true
                        this.loading = false
                    }
                }).catch(err => {
                ErrorResolver.checkErrors(this, err)
                this.loading = false
            })
        },

        print() {
            window.print()
        },
    },


    watch: {
        selectedSession: function (newVal) {
            if (newVal != null) {
                this.getPayment()
            }
        },

        getUser: function () {
            this.fetchSessionsForPayment()
        },
    },

    created() {
        this.fetchSessionsForPayment()
    },


    mounted() {

    }
}
</script>


<style scoped>
.ax {
    width: 210mm
}

@media print {
    #doc {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
    }

    #actions {
        display: none;
        height: 0;
        width: 0;
    }
}

@page {
    margin: 0;
}
